// Utilities
import baseAxios from "./base"

const UserApi = {
  update: (params = {}) => {
    return baseAxios.put("/user", params)
  },
}

export default UserApi
